import { useQuery, UseQueryResult } from 'react-query';
import { APIErrorType } from '../../api';
import { fetchLessons, LessonType } from '../../api/lesson';

export type useLessonsReturnType = UseQueryResult<LessonType[]>;

export function useLessons(): useLessonsReturnType {
  return useQuery<LessonType[], APIErrorType>('lessons', fetchLessons, {
    staleTime: 30 * 1000,
    retry: false
  });
}
